


































import { Component, Vue } from 'vue-property-decorator';
import VButton from '@/components/VButton.vue';
import { Action } from 'vuex-class';
import * as types from '@/store/account/types';
import SmallCard from '@/components/cards/SmallCard.vue';
import FormField from '@/utilities/validation/formfield';
import ValidatedForm from '@/utilities/validation/validatedform';

@Component({
  components: { VButton, SmallCard },
})
export default class ChangePassword extends Vue {

  @Action('changePassword', { namespace: 'account' }) private changePassword!: types.ChangePasswordAction;

  private wrongPassword: boolean = false;
  private submitting: boolean = false;
  private passwordField = new FormField((value, dirty) => value.length > 5, '');
  private repeatField = new FormField((value, dirty) => value === this.passwordField.value, '');

  private passwordForm = new ValidatedForm({
    password: this.passwordField,
    repeat: this.repeatField,
  });

  get passwordFormValid() {
    return this.passwordForm.fieldValidity();
  }

  private submit() {
    if (this.passwordForm.formValid()) {
      this.submitting = true;
      this.changePassword({ newPassword: this.passwordField.value })
      .then(() => {
        this.wrongPassword = false;
        this.$router.push({ name: 'login' });
      }).catch(() => {
        this.wrongPassword = true;
      }).finally(() => {
        this.submitting = false;
      });
    }
  }
}
